import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import jwt_decode from "jwt-decode";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import * as moment from "moment";
import DatePicker from "react-datepicker";

var yesterday = new Date(Date.now() + 0 * 40 * 60 * 1000);

var yestSend = moment(yesterday).format('YYYY-MM-DD');

class ViewTicketStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createdDate:yestSend,
        }
    }

    handleFromChange = date => { //alert(date);
        var date_filter = moment(date).format('YYYY-MM-DD');
        this.setState({
            createdDate: date_filter
        });
    };

    render() {
        return (
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style}/>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                <div className="col-mid-12 no-padd">
                                    <div className="card title-card-bottom-space">
                                        <div className="header">
                                            <h4 className="title">View Ticket Status</h4>
                                            <p className="category"></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>

                                <div className=" content bgcolor">
                                    <div className=" container-fluid ">

                                        <div className="p-10">

                                            <div className="">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="col-md-1">
                                                        <h5>Filter</h5>
                                                        </div>
                                                        <div className="col-md-2">
                                                           <label>Select Status</label>
                                                        <select id="Status" name="Status" className="form-control col-md-2" >
                                                            <option value="Select...">[Status]</option>
                                                        </select>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <label>Select UTID</label>
                                                            <select id="UTID" name="UTID" className="form-control col-md-2" >
                                                                <option value="Select...">[UTID]</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <label>Select Issue Type</label>
                                                            <select id="IssueType" name="IssueType" className="form-control col-md-2" >
                                                                <option value="Select...">[Issue Type]</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <label>Created Date</label>
                                                            <DatePicker
                                                                dateFormat="dd-MM-yyyy"
                                                                selected={Date.parse(this.state.createdDate)}
                                                                onChange={this.handleFromChange}
                                                                maxDate={new Date()}
                                                            />
                                                        </div>

                                                        <div className="col-md-2">
                                                            <label>Store Name</label>
                                                            <select id="StoreName" name="StoreName" className="form-control col-md-2" >
                                                                <option value="Select...">[Store Name]</option>
                                                            </select>
                                                        </div>
<div className="clearfix"></div>

                                                    <hr />
                                                    </div>


                                                    <div className="col-md-12">
                                                        <table className="table table-striped table-hover">
                                                            <thead>
                                                            <tr>
                                                                <th>S. No</th>
                                                                <th>Ticket Number</th>
                                                                <th>UTID</th>
                                                                <th>Store Name</th>
                                                                <th>Created Date</th>
                                                                <th>Resolved Date</th>
                                                                <th>Issue Type</th>
                                                                <th>Status</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td>0001</td>
                                                                <td>R12345</td>
                                                                <td>Store 1</td>
                                                                <td>20-7-2020</td>
                                                                <td>22-7-2020</td>
                                                                <td>Hardware Issue</td>
                                                                <td>Resolved</td>
                                                            </tr>
                                                            <tr>
                                                                <td>2</td>
                                                                <td>00010</td>
                                                                <td>G3412345</td>
                                                                <td>Store 5</td>
                                                                <td>19-7-2020</td>
                                                                <td>20-7-2020</td>
                                                                <td>Teminal Issue</td>
                                                                <td>Open</td>
                                                            </tr>
                                                            <tr>
                                                                <td>3</td>
                                                                <td>00021</td>
                                                                <td>R1232345</td>
                                                                <td>Store3 1</td>
                                                                <td>20-7-2020</td>
                                                                <td>22-7-2020</td>
                                                                <td>Software Issue</td>
                                                                <td>Resolved</td>
                                                            </tr>
                                                            <tr>
                                                                <td>4</td>
                                                                <td>000321</td>
                                                                <td>R1223345</td>
                                                                <td>Store 41</td>
                                                                <td>10-7-2020</td>
                                                                <td>12-7-2020</td>
                                                                <td>Hardware Issue</td>
                                                                <td>Resolved</td>
                                                            </tr>
                                                            <tr>
                                                                <td>5</td>
                                                                <td>000431</td>
                                                                <td>R1234345</td>
                                                                <td>Store 211</td>
                                                                <td>20-7-2020</td>
                                                                <td>22-7-2020</td>
                                                                <td>Hardware Issue</td>
                                                                <td>Resolved</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="">

                                                        <div className="clearfix"></div>
                                                        <div className="gap_ver"></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>



                                <div className="footer">
                                    <div className="stats"><i></i></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ViewTicketStatus;